<template>
  <div class="page-content">
    <div id="PrivacyContent">
      <div id="title">
        <h1>Informativa privacy</h1>
      </div>
<h2>Anonimato garantito</h2>
<p>Abbiamo deciso di non raccogliere <b>nessuno</b> dei tuoi dati, così è più semplice dirti che non li condividiamo con nessuno, non li abbiamo.</p>
<p>Il nickname che scegli è temporaneo, e si cancella automaticamente un'ora dopo l'ultimo utilizzo.</p>
<p>Il sito https://briscolachiamata.online fa affidamento su alcuni cookies funzionali che contengono esclusivamente informazioni relative al funzionamento del gioco e che non sono in alcun modo classificabili come tracking cookies.</p>
<p>Il sito https://briscolachiamata.online utilizza Google Analytics per ricavare dati aggregati relativi alle statistiche di utilizzo e si appoggia a Google Adsense per supportarsi tramite la visualizzazione di pubblicità; potete consultare la informativa privacy Google al seguente indirizzo: https://policies.google.com/privacy?hl=it</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
};
</script>
<style scoped>
#PrivacyContent {
  padding: 4em;
  padding-top: 0em;
  padding-bottom: 5em;
  text-align: left;
}
h2 {
  padding: 1em;
  padding-top: 2em;
}
#title {
  display: flex;
  justify-content: center;
}
</style>
